import React, { lazy } from 'react';
import { useTrackSection } from '../utils/useTrackSection';
const tomes = [{
  label: 'Tomo 1',
  sublabel: 'Gestión Legal y Administrativa',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777592452/ChatGPT_Image_30_abr_2026_08_08_53_p.m._qws2o1.webp'
}, {
  label: 'Tomo 2',
  sublabel: 'Evaluación Clínica',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777592452/ChatGPT_Image_30_abr_2026_08_09_00_p.m._bvpjdj.webp'
}, {
  label: 'Tomo 3',
  sublabel: 'Traumatología y Ortopedia',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777592452/ChatGPT_Image_30_abr_2026_08_09_36_p.m._m8tzct.webp'
}, {
  label: 'Tomo 4',
  sublabel: 'Internación Domiciliaria',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777592453/ChatGPT_Image_30_abr_2026_08_11_32_p.m._xqeuyp.webp'
}, {
  label: 'Tomo 5',
  sublabel: 'Neurociencia del Dolor',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777592452/ChatGPT_Image_30_abr_2026_08_13_47_p.m._qhm4hs.webp'
}, {
  label: 'Tomo 6',
  sublabel: 'Gestión de Carrera',
  image: 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_180/v1777592453/ChatGPT_Image_30_abr_2026_08_14_38_p.m._xdy7gc.webp'
}];
const features = ['✅ Protocolos de evaluación clínica listos para aplicar', '✅ Plantillas de informes para Obras Sociales y auditorías', '✅ Protocolos de traumatología por fases listos para usar', '✅ 10 editables prácticos para gestión, agenda y seguimiento de pacientes'];
export function ProductShowcase() {
  useTrackSection('product-showcase', 'Product Showcase Section');
  return <section id="product-showcase" className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(235,248,255) 100%)',
    fontFamily: 'var(--font-system)'
  }} data-id="element-251">
      <div className="mx-auto max-w-4xl text-center" data-id="element-252">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide rounded-full px-4 py-1.5" style={{
        color: '#0077B6',
        border: '1px solid rgba(0,119,182,0.50)',
        backgroundColor: 'rgba(0,119,182,0.05)'
      }} data-id="element-253">
          🏆 El sistema clínico más completo para kinesiólogos de Argentina
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold m-0 mb-4" style={{
        color: '#0077B6'
      }} data-id="element-254">
          MEGAPACK KINESIOLOGÍA RESUELTA
        </h3>

        {/* Description */}
        <p className="max-w-2xl text-gray-800 m-0 mb-8 text-[14px]" data-id="element-255">
          <strong data-id="element-256">
            6 Tomos + 6 Bonos — Sistema Clínico Completo — Todo resuelto.
          </strong>
          <br data-id="element-257" />
          +350 páginas · Protocolos de evaluación listos · Plantillas de
          informes para Obras Sociales · Protocolos de traumatología por fases ·
          Blindaje legal completo · Sistema de seguimiento de pacientes ·
          Gestión de carrera profesional · Listo para usar hoy.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-258">
          <div className="grid grid-cols-6 gap-3" data-id="element-259">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-260">
                {/* Card con imagen */}
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-gray-100" data-id="element-261">
                  <img src={tome.image} alt={`${tome.label} — ${tome.sublabel}`} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-262" />
                </div>

                {/* Título separado abajo */}
                <div className="text-center" data-id="element-263">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-264">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-265">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge inferior */}
          <div className="mt-6 flex justify-center" data-id="element-266">
            <div className="whitespace-nowrap text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" style={{
            backgroundColor: '#0077B6'
          }} data-id="element-267">
              6 TOMOS COMPLETOS · SISTEMA CLÍNICO PROFESIONAL
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-268">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 rounded-xl px-4 py-3 text-left" style={{
          backgroundColor: 'rgba(0,119,182,0.05)',
          border: '1px solid rgba(0,119,182,0.20)'
        }} data-id="element-269">
              <span className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center" style={{
            backgroundColor: 'rgba(0,119,182,0.15)'
          }} data-id="element-270">
                <svg className="w-3 h-3" style={{
              color: '#0077B6'
            }} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-271">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-272" />
                </svg>
              </span>
              <span className="text-xs font-semibold text-gray-800 leading-snug" data-id="element-273">
                {feature.replace('✅ ', '')}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}